import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  selector: 'modulo-card-item',
  templateUrl: './modulo-item.component.html',
  styleUrls: ['./modulo-item.component.scss']
})
export class ModuloItemComponent implements OnInit, OnDestroy {
  @Input() modulo: any = '';
  @Input() viewMode: 'grilla' | 'lista' = 'grilla';
  @Output() dirigirirAlModulo = new EventEmitter<any>();
  isLoading = false;

  constructor() { }

  ngOnInit(): void {
    console.log('this.modulo: ', this.modulo);
    console.log('this.viewMode: ', this.viewMode); 
    // console.log(this.dirigirirAlModulo);
  }


  ngOnDestroy(): void {
    this.isLoading = false;
  }

  setLoading(value: boolean): void {
    this.isLoading = value;
  }
}
